export function formatNumber(value: number): string {
  if (value >= 10000) {
    const w = value / 10000;
    return `${w >= 10 ? w.toFixed(0) : w.toFixed(1)}万`;
  }
  return value.toLocaleString("zh-CN");
}

export function formatPercent(value: number): string {
  return `${Math.round(value)}%`;
}

export function formatDate(dateStr: string): string {
  const [y, m, d] = dateStr.split("-");
  return `${y} 年 ${Number(m)} 月 ${Number(d)} 日`;
}

export function formatRelative(dateStr: string): string {
  const target = new Date(`${dateStr}T00:00:00`).getTime();
  const now = new Date("2026-09-10T00:00:00").getTime();
  const days = Math.max(1, Math.round((now - target) / 86400000));
  if (days === 1) return "今天更新";
  if (days === 2) return "昨天更新";
  return `${days} 天前更新`;
}